import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, useMediaQuery } from "@mui/material";
import { Button } from "antd";
import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../contexts/LoginContext";
import { addPredictorType } from "../../services/CollegePredictorServices/addPredictorType";
import CollegePredictors from "../CollegePredictors";
import PreferenceList from "./PreferenceList";

function CollegePredictorDashboard() {
    const isMobile = useMediaQuery("(max-width:768px)");

    const { UserId, userDetail, setUserDetail } = useContext(LoginContext);

    const [selected, setSelected] = useState(null);
    const [selectedView, setSelectedView] = useState(null);
    const [predictorType, setPredictorType] = useState(null);

    const [confirmModal, setConfirmModal] = useState(false);
    const [pendingPredictor, setPendingPredictor] = useState(null);
    const [selectedEngineeringPredictor, setSelectedEngineeringPredictor] = useState(null);
    const [saving, setSaving] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info"
    });

    useEffect(() => {
        if (userDetail?.predictorType) {
            setPredictorType(userDetail.predictorType);
        }
    }, [userDetail]);

    const showMessage = (message, severity = "info") => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };
    const handleCardClick = (type) => {

        if (type === "medical") {
            showMessage("Medical predictor will be available soon.", "info");
            return;
        }

        if (predictorType) {

            if (
                predictorType === "pcm" &&
                (type === "pcm" || type === "jee")
            ) {
                setSelected(type);
                return;
            }
            if (predictorType === type) {
                setSelected(type);
            } else {
                showMessage(
                    `Your account is locked to ${formatNameMessage(predictorType)} predictor.`,
                    "warning"
                );
            }

            return;
        }

        setPendingPredictor(type);
        setConfirmModal(true);
    };

    const formatName = (code) => {

        switch (code) {
            case "pcm": return "Engineering (MHT-CET)";
            case "pharma": return "Pharmacy";
            case "mba": return "MBA";
            case "jee": return "Engineering (JEE)";

            // case "medical": return "Medical";
            default: return code;
        }

    };


    const formatNameMessage = (code) => {

        switch (code) {
            case "pcm": return "Engineering";
            case "pharma": return "Pharmacy";
            case "mba": return "MBA";
            case "jee": return "Engineering";

            // case "medical": return "Medical";
            default: return code;
        }

    };
    const getEmoji = (code) => {

        switch (code) {
            case "pcm": return "🎓";
            case "pharma": return "💊";
            case "mba": return "💼";
            case "jee": return "⚙️";
            // case "medical": return "🩺";
            default: return "🎯";
        }

    };

    const isEngineeringLicense = predictorType === "pcm";

    const getAvailablePredictors = () => {

        if (predictorType === "pcm") {
            return [
                {
                    key: "pcm",
                    title: "MHT-CET",
                    desc: "Predict colleges using MHT-CET rank or percentile.",
                    color: "#e8f3ff"
                },
                {
                    key: "jee",
                    title: "JEE Main",
                    desc: "Predict Maharashtra engineering colleges through JEE Main admissions.",
                    color: "#dfe0e2"
                }
            ];
        }

        if (predictorType === "pharma") {
            return [{
                key: "pharma",
                title: "Pharmacy",
                desc: "",
                color: "#fff3e6"
            }];
        }

        if (predictorType === "mba") {
            return [{
                key: "mba",
                title: "MBA",
                desc: "",
                color: "#e9f9ef"
            }];
        }

        return [];
    };
    const confirmSelection = async () => {

        if (!pendingPredictor) return;

        setSaving(true);

        try {

            const res = await addPredictorType(UserId, pendingPredictor);

            if (res?.data) {

                setUserDetail({
                    ...userDetail,
                    predictorType: pendingPredictor
                });

                // setPredictorType(pendingPredictor);
                // setConfirmModal(false);
                // setSelected(pendingPredictor);
                setPredictorType(pendingPredictor);
                setConfirmModal(false);

                setSelected(null);
                setSelectedView(null);

                showMessage(
                    `${formatNameMessage(pendingPredictor)} predictor activated successfully.`,
                    "success"
                );

            }

        } catch {

            showMessage("Something went wrong. Please try again.", "error");

        }

        setSaving(false);

    };

    // const handleBack = () => setSelected(null);
    const handleBack = () => {
        setSelected(null);
        setSelectedView(null);
        setSelectedEngineeringPredictor(null);
    };

    const renderCard = (key, title, desc, color) => {

        const disabled =
            predictorType &&
            !(
                predictorType === "pcm" &&
                (key === "pcm" || key === "jee")
            ) &&
            predictorType !== key;

        return (

            <div
                onClick={() => handleCardClick(key)}
                style={{
                    ...cardStyle,
                    background: color,
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? "not-allowed" : "pointer"
                }}
                onMouseEnter={(e) => {
                    if (!disabled) {
                        e.currentTarget.style.transform = "translateY(-4px)";
                        e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.12)";
                    }
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                    e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)";
                }}
            >

                <div style={iconStyle}>{getEmoji(key)}</div>

                <h3>{title}</h3>

                <p style={descStyle}>{desc}</p>

            </div>

        );

    };

    const renderEngineeringCard = (key, title, desc, color) => {

        return (

            <div
                onClick={() => setSelectedEngineeringPredictor(key)}
                style={{
                    ...cardStyle,
                    background: color,
                    cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow =
                        "0 12px 30px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                    e.currentTarget.style.boxShadow =
                        "0 8px 20px rgba(0,0,0,0.08)";
                }}
            >

                <div style={iconStyle}>{getEmoji(key)}</div>

                <h3>{title}</h3>

                <p style={descStyle}>{desc}</p>

            </div>

        );

    };
    const handleEngineeringBack = () => {
        setSelectedEngineeringPredictor(null);
        setSelected(null);
        setSelectedView(null);
    };
    const renderSelectedView = () => {
        const activePredictor =
            predictorType === "pcm"
                ? selectedEngineeringPredictor
                : predictorType;

        return (

            <div style={{ width: "100%", maxWidth: 980, margin: "0 auto", }}>
                {predictorType === "pcm" && selectedEngineeringPredictor && (
                    <div style={{ textAlign: "left", marginBottom: 16 }}>
                        <button
                            onClick={handleEngineeringBack}
                            style={backButtonStyle}
                        >
                            ← Back
                        </button>
                    </div>
                )}
                {/* 
                <div style={activeBannerStyle}>
                    <div>
                        <strong>Active Predictor:</strong>
                        <span style={{ marginLeft: 8 }}>{formatName(predictorType)}</span>
                    </div>

                    <div style={{ color: "#666", fontSize: 13 }}>
                        This predictor was selected when you purchased the product and cannot be changed later.
                    </div> 
                </div>
                    */}

                <div
                    style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: 10,
                        justifyContent: "space-between",
                        marginTop: 22,
                        alignItems: "stretch"
                    }}
                >

                    <div
                        style={{
                            ...bigCardStyle,
                            padding: isMobile ? 18 : 28,
                            border: "1px solid rgba(2,40,80,0.08)",
                            boxShadow: "0 10px 30px rgba(2,40,80,0.06)"
                        }}
                        onClick={() => {
                            setSelected(activePredictor);
                            setSelectedView("predictor");
                        }}
                    >
                        {isMobile ? (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    marginBottom: 12,
                                    textAlign: "left"
                                }}
                            >
                                <div style={{ fontSize: 32, flexShrink: 0 }}> {getEmoji(activePredictor)}</div>

                                <div>
                                    <h3 style={{ margin: 0 }}>{formatName(activePredictor)}</h3>
                                </div>
                            </div>) : (
                            <>
                                <div style={{ fontSize: 42, marginBottom: 10 }}>
                                    {getEmoji(activePredictor)}
                                </div>

                                <h2>{formatName(activePredictor)}</h2>
                            </>
                        )}

                        <p style={{ marginTop: 6, color: "#444" }}>
                            Use your rank or percentile to get AI-powered college predictions.
                        </p>

                        {!isMobile && (<div style={{ marginTop: 16 }}>
                            <Button
                                type="primary"
                                size="large"
                                style={{
                                    ...OpenPredictorbtn,
                                    width: isMobile ? "100%" : "auto"
                                }}
                            >
                                Open Predictor
                            </Button>
                        </div>)}

                    </div>
                    <div
                        style={{
                            ...bigCardStyle,
                            padding: isMobile ? 18 : 28,
                            border: "1px solid rgba(2,40,80,0.08)",
                            boxShadow: "0 10px 30px rgba(2,40,80,0.06)",
                            cursor: "pointer",
                            position: "relative",
                            transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-4px)";
                            e.currentTarget.style.boxShadow =
                                "0 12px 30px rgba(0,0,0,0.12)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0px)";
                            e.currentTarget.style.boxShadow =
                                "0 10px 30px rgba(2,40,80,0.06)";
                        }}
                        onClick={() => {
                            if (activePredictor == "jee" ? userDetail?.jeeRank === null : userDetail?.mhtcetRank === null) {

                                showMessage(
                                    "Please add your rank in AI Predictor before proceeding.",
                                    "warning"
                                );

                                return;
                            }

                            setSelected(activePredictor);
                            setSelectedView("preference");
                        }}
                    >
                        {isMobile ? (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    marginBottom: 12,
                                    textAlign: "left"
                                }}
                            >
                                <div style={{ fontSize: 22, flexShrink: 0 }}>📝</div>

                                <div>
                                    <h3 style={{ margin: 0 }}>Your Preference List</h3>
                                    <small>Save and manage your favorite colleges</small>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div style={{ fontSize: 42, marginBottom: 10 }}>📝</div>
                                <h2>Your Preference List</h2>
                                <small>Save and manage your favorite colleges</small>
                            </>
                        )}
                        {/* want to add divider line here */}
                        <div
                            style={{
                                width: "100%",
                                height: "1px",
                                background: "#e5e7eb",
                                margin: "2px 0"
                            }}
                        />
                        <p
                            style={{
                                color: "#444",
                                lineHeight: 1.6
                            }}
                        >
                            Build round-wise preference lists, view AI suggestions,and track allotments — all in one place.
                        </p>
                        <div style={{ marginTop: 8 }}>
                            <Button
                                type="primary"
                                size="large"
                                style={{
                                    ...OpenPredictorbtn,
                                    width: isMobile ? "100%" : "auto"
                                }}
                            >
                                Add College
                            </Button>
                        </div>

                        {/* <small style={{ color: "#002147" }}>
                            Note: Please add your rank in AI Predictor before proceeding.
                        </small> */}
                        {/* top right arrow */}
                        {/* <div
                            style={{
                                position: "absolute",
                                bottom: 18,
                                right: 18,
                                fontSize: 20,
                                color: "#002147",
                                fontWeight: 700
                            }}
                        >
                            →
                        </div> */}
                        {/* <div style={{ marginTop: 18 }}>
                            <Button
                                type="primary"
                                size="large"
                                style={{
                                    ...OpenPredictorbtn,
                                    width: isMobile ? "100%" : "auto"
                                }}
                            >
                                Open Preference List
                            </Button>
                        </div> */}
                    </div>
                </div>

            </div>

        );

    };

    return (

        <div style={container}>
            {console.log("userdeatils ", userDetail)}
            {(userDetail?.length === 0 || userDetail === null) ?
                (
                    <div style={container}>
                        Loading...
                    </div>
                )
                : (!selected && !predictorType && (

                    <>
                        <h2 style={title}>Choose Your College Predictor</h2>

                        <p style={subtitle}>
                            Select your predictor to begin. Once chosen, it can't be changed later.</p>

                        <div style={cardWrapper}>

                            {renderCard(
                                "pcm",
                                "Engineering",
                                "Predict colleges using rank or percentile.",
                                "#e8f3ff"
                            )}
                            {renderCard(
                                "pharma",
                                "Pharmacy",
                                "Find Pharmacy colleges using entrance results.",
                                "#fff3e6"
                            )}

                            {renderCard(
                                "mba",
                                "MBA",
                                "Find MBA colleges using entrance scores.",
                                "#e9f9ef"
                            )}

                        </div>
                    </>
                ))}
            {!selected &&
                predictorType === "pcm" &&
                !selectedEngineeringPredictor && (

                    <>
                        <h2 style={title}>Choose Engineering Predictor</h2>

                        <p style={subtitle}>
                            Select which engineering predictor you want to continue with.
                        </p>

                        <div style={cardWrapper}>

                            {renderEngineeringCard(
                                "pcm",
                                "MHT-CET",
                                "Predict colleges using MHT-CET rank or percentile.",
                                "#e8f3ff"
                            )}

                            {renderEngineeringCard(
                                "jee",
                                "JEE Main",
                                "Predict Maharashtra engineering colleges using JEE Main.",
                                "#dfe0e2"
                            )}

                        </div>

                    </>
                )}
            {/* 
            {!selected &&
                predictorType &&
                predictorType !== "pcm" &&
                renderSelectedView()} */}
            {!selected &&
                predictorType &&
                (predictorType !== "pcm" || selectedEngineeringPredictor) &&
                renderSelectedView()}

            {/* {selected && (
                <div style={{ marginTop: 6 }}>
                    <div style={{ textAlign: 'left' }}>
                        <button onClick={handleBack} style={backButtonStyle}>
                            ← Back
                        </button>
                    </div>
                    <div style={{ marginTop: 8 }}>
                        {
                            <CollegePredictors predictor={selected} />
                        }</div>
                </div>

            )} */}
            {/* preference lists */}
            {selected && (
                <div style={{ marginTop: 6 }}>
                    {/* {selectedView === "predictor" && (<div style={{ textAlign: 'left' }}>
                        <button onClick={handleBack} style={backButtonStyle}>
                            ← Back
                        </button>
                    </div>)} */}

                    <div style={{ marginTop: 8 }}>

                        {selectedView === "predictor" && (
                            <CollegePredictors predictor={selected} handleBack={handleBack} />
                        )}

                        {selectedView === "preference" && (
                            <PreferenceList predictor={selected} handleBack={handleBack} />
                        )}

                    </div>
                </div>
            )}

            <Dialog
                open={confirmModal}
                fullWidth
                maxWidth="xs"
            >

                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'rgb(245, 246, 250)',
                        boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.05)'
                    }}
                >
                    <h4 style={{
                        color: '#001124',
                        fontFamily: 'Poppins',
                        lineHeight: '1.42857143',
                    }}>

                        {"Confirm Predictor Selection"}
                    </h4>
                </DialogTitle>

                <DialogContent
                    sx={{
                        margin: '20px auto',
                        padding: '15px 20px',
                        fontFamily: 'Poppins',
                        color: '#333',
                        fontSize: '12px'
                    }}
                >

                    You are selecting <b>{formatNameMessage(pendingPredictor)}</b> predictor.

                    <br /><br />

                    This choice is permanent and cannot be changed later.

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => setConfirmModal(false)}>
                        Cancel
                    </Button>

                    <Button
                        type="primary"
                        loading={saving}
                        onClick={confirmSelection}
                    >
                        Confirm
                    </Button>

                </DialogActions>

            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity}
                    sx={{ fontSize: "15px", width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </div>

    );

}

const container = {
    padding: "15px 12px",
    width: "100%",
    maxWidth: 1300,
    margin: "auto",
    textAlign: "center",
    boxSizing: "border-box",
    // background: "#4d5cff"
};

const title = {
    fontSize: "clamp(24px, 5vw, 30px)",
    fontWeight: 700,
    marginBottom: 10
};

const subtitle = {
    color: "#555",
    marginBottom: 30,
    fontSize: 14,
    lineHeight: 1.6,
    padding: "0 10px"
};

const cardWrapper = {
    display: "flex",
    gap: 25,
    flexWrap: "wrap",
    justifyContent: "center"
};

const cardStyle = {
    padding: 25,
    borderRadius: 12,
    width: "100%",
    maxWidth: 240,
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    transition: "all 0.2s ease",
    border: "1px solid #eee",
    boxSizing: "border-box"
};

const iconStyle = {
    fontSize: 36,
    marginBottom: 10
};

const descStyle = {
    fontSize: 14,
    color: "#444",
    marginBottom: 15
};

const backButtonStyle = {
    padding: "8px 16px",
    fontSize: 14,
    cursor: "pointer",
    borderRadius: 8,
    color: "#fff",
    border: '1px solid #002147',
    backgroundColor: '#002147',
};

const bigCardStyle = {
    flex: 1,
    minWidth: 280,
    width: "100%",
    borderRadius: 12,
    // padding: isMobile ? 18 : 28,
    textAlign: "center",
    background: "#ffffff",
    boxSizing: "border-box"
};

const activeBannerStyle = {
    background: "#f3f6fb",
    padding: 16,
    borderRadius: 8,
    maxWidth: 980,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 6
};
const OpenPredictorbtn = {
    boxShadow: "rgba(0, 0, 0, 0.05)",
    backgroundColor: "rgb(0, 33, 71)",
    /* background: #002147; */
    color: "#fff",
}

export default CollegePredictorDashboard;